import { render, staticRenderFns } from "./InternalAdjustments.vue?vue&type=template&id=974b8158&scoped=true&"
import script from "./InternalAdjustments.vue?vue&type=script&lang=js&"
export * from "./InternalAdjustments.vue?vue&type=script&lang=js&"
import style0 from "./InternalAdjustments.vue?vue&type=style&index=0&id=974b8158&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "974b8158",
  null
  
)

export default component.exports